import React from 'react';

const FIELDS = [
  ['contactName', 'Contact name'], ['phone', 'Phone number'], ['email', 'Email'],
  ['website', 'Website'], ['address', 'Address'], ['instagram', 'Instagram handle'],
  ['facebook', 'Facebook handle'], ['linkedin', 'LinkedIn handle'], ['x', 'X handle']
];

const FlyerContactPreferences = ({ accountEmail, displayEmail, visibility, onEmailChange, onVisibilityChange }) => (
  <section className="mt-6 pt-6 border-t border-gray-100" aria-labelledby="flyer-contact-heading">
    <h3 id="flyer-contact-heading" className="font-semibold text-gray-900">What appears on your flyers</h3>
    <p className="text-sm text-gray-600 mt-1">Choose which saved details to include. Hidden or blank details are left out automatically. Your company name and logo stay visible.</p>
    <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-4">
      <p className="text-sm text-gray-700 break-words"><strong>Sign-in &amp; notifications:</strong> {accountEmail}</p>
      <p className="text-sm text-gray-600 mt-1">Password resets, notifications, and emailed flyer downloads still go to this account email. Changing your flyer email below does not change your sign-in.</p>
    </div>
    <div className="mt-4">
      <label htmlFor="flyer-display-email" className="block text-sm font-medium text-gray-700 mb-2">Email displayed on flyers</label>
      <input id="flyer-display-email" type="email" value={displayEmail} onChange={event => onEmailChange(event.target.value)} className="input-field" placeholder={accountEmail} maxLength={254} autoCapitalize="none" autoCorrect="off" spellCheck="false" aria-describedby="flyer-display-email-help" />
      <div className="mt-2 flex flex-wrap items-start justify-between gap-2">
        <p id="flyer-display-email-help" className="text-sm text-gray-500">Use any business email you want to publish, or leave blank to use your account email. Uncheck Email below to hide it.</p>
        <button type="button" className="text-sm font-medium text-primary-700 underline underline-offset-2 shrink-0 py-1" onClick={() => onEmailChange(accountEmail)}>Use account email</button>
      </div>
    </div>
    <fieldset className="mt-5">
      <legend className="text-sm font-medium text-gray-800 mb-2">Include on flyers</legend>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {FIELDS.map(([field, label]) => (
          <label key={field} className="flex items-center gap-3 rounded-lg border border-gray-200 p-3 text-sm text-gray-800 cursor-pointer">
            <input type="checkbox" className="h-4 w-4 accent-[#262C68] shrink-0" checked={visibility[field] !== false} onChange={event => onVisibilityChange(field, event.target.checked)} aria-label={`Show ${label.toLowerCase()} on flyers`} />
            {label}
          </label>
        ))}
      </div>
      <p className="text-xs text-gray-500 mt-3">Applies to previews, downloads, emailed attachments, and social images. Each design uses the fields that fit its layout; hidden details remain saved in your profile.</p>
    </fieldset>
  </section>
);

export default FlyerContactPreferences;
